<template lang="pug">
  .d-flex.align-center(v-if="item")
    v-radio.ma-0(v-if="hasRadioButton" :value="item")
    div.ml-2
      .text-sm.font-semibold.mb-1 {{ item.offer.name }}
      .text-xs {{ item.code }}
      .d-flex.align-center
        .text-xs.mr-2(v-if="item.expired_at") Use before {{ item.expired_at | humanizeDate }}
        y-chip.py-1.px-3.round-3xl.neutral300
          v-icon(small) $yzi-alert-circle
          .text-xs.ml-2 {{ item.redeemable_qty }} left
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    hasRadioButton: {
      type: Boolean,
    }
  },
}
</script>


<style scoped>

</style>